import React from 'react';
import Button from '../Button';
import { FaArrowRight } from 'react-icons/fa';
import team from '../../assets/team.png';

export default function CTASection() {
  return (
    <section id="cta" className="py-4 md:py-10 px-4 md:px-16 pb-4">
      <div className="container mx-auto">
        <div className="bg-cta-gradient rounded-2xl p-8 md:p-12 overflow-hidden">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h2 className="mb-6 text-white text-2xl text-3xl font-bold -leading-[60px] tracking-[0%]">
                <span className="">Rejoignez la révolution</span>
                <span className="block mt-4"> numérique africaine</span>
              </h2>
              <p className="mb-6 text-[#ECFDF5] text-lg font-semibold leading-[30px] tracking-[0%]">
                Commencez dès maintenant et boostez votre productivité avec Easy Suite. Simple, rapide, efficace.
              </p>
              <div className="flex flex-wrap font-segoe gap-4">
                <Button className="btn-pill-green hover:bg-white px-6 py-2 rounded-full font-semibold">
                  Commencer maintenant <FaArrowRight className="w-4 h-3 ml-2" />
                </Button>
                <Button className="btn-green hover:bg-white px-6 py-2 rounded-full font-semibold">
                  Essayer gratuitement
                </Button>
              </div>
            </div>

            <div className="w-auto h-48 md:h-[250px] p-0 m-0 rounded-xl">
              <img src={team} className="w-full h-full rounded-xl object-cover" alt="Équipe Easy Suite" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
